import { Mapper } from "master-locations-library/master-locations-library/src/lib/core/base";
import { OpeningHoursForPPLocation } from "master-locations-library/master-locations-library/src/lib/core/domain/models";
import { OpeningHoursForPPLocationWebEntity } from "./opening-hours-for-PP-location-web-entity";

export class OpeningHoursForPPLocationMapper extends Mapper<
  OpeningHoursForPPLocationWebEntity,
  OpeningHoursForPPLocation
> {
  mapFrom(param: OpeningHoursForPPLocationWebEntity): OpeningHoursForPPLocation {
    return {
        day: param.day,
        fromTime: param.fromTime,
        toTime: param.toTime
    };
  }

  mapTo(param: OpeningHoursForPPLocation): OpeningHoursForPPLocationWebEntity {
    return {
        day: param.day,
        fromTime: param.fromTime,
        toTime: param.toTime
    };
  }
}